import * as React from 'react';

import { useParams } from 'js/lib/useRouter';

import { enterpriseDomainsIndexConfig } from 'bundles/enterprise-learner-search/components/search/enterpriseIndexConfig';
import SearchProvider from 'bundles/search-common/providers/SearchProvider';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

const EnterpriseBrowseDomainPageDataProvider = ({ children }: { children: React.ReactNode }) => {
  const params = useParams();
  const program = useProgram();

  if (!program) {
    return null;
  }

  return (
    <SearchProvider
      key={`${params.domainSlug}:${params.subdomainSlug}`}
      searchConfigs={enterpriseDomainsIndexConfig({
        searchContext: { searchInPrograms: { programIds: [program.id] } },
        domainId: params.domainSlug,
        subdomainId: params.subdomainSlug,
      })}
    >
      {children}
    </SearchProvider>
  );
};

export default EnterpriseBrowseDomainPageDataProvider;
